import { BlockOneshopUpdatingOptionsSelectPaymentMethod } from 'shared/api/client';
import { FormattedProps } from './types';
import { Link, TitleHtmlTag } from 'shared/types';
import { getLinkHref } from 'shared/helpers/uri';

export default function propsFormatter(
  content: BlockOneshopUpdatingOptionsSelectPaymentMethod['content']
): FormattedProps {
  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    phoneNumberTitle: {
      label: content.phone_number_title.label ?? '',
      htmlTag: content.phone_number_title.htmlTag
        ? (content.phone_number_title.htmlTag as TitleHtmlTag)
        : undefined
    },
    mobileMoneyTitle: {
      label: content.mobile_money_title.label ?? '',
      htmlTag: content.mobile_money_title.htmlTag
        ? (content.mobile_money_title.htmlTag as TitleHtmlTag)
        : undefined
    },
    submitButton: {
      label: content.submit_button.label ?? '',
      link: getLinkHref(
        content.submit_button.link ? (content.submit_button.link as Link) : null
      )
    },
    previousButtonLabel: content.previous_button.label ?? null,
    redirectLinkToStart: getLinkHref(content.redirect_link_to_start as Link)
  };
}
